import axios from '../../api';

const BASE = process.env.REACT_APP_URL;

export const getTflMonitoring = () => axios.get(`${BASE}/tfl-monitoring`);
export const getTflDetail = (tflId) => axios.get(`${BASE}/tfl-monitoring/${tflId}`);